import type {
  GetShopPaymentMethodsResponse,
  GetUserPaymentMethodsResponse,
} from '@fourthwall/services/dist/PaymentApiClient'

export const filterOutExistingPaymentMethods = (
  userPaymentMethods?: GetUserPaymentMethodsResponse,
  shopPaymentMethods?: GetShopPaymentMethodsResponse,
) =>
  userPaymentMethods?.filter(
    (userPaymentMethod) =>
      !shopPaymentMethods?.result.some(
        (shopPaymentMethod) => shopPaymentMethod.customerPaymentMethodId === userPaymentMethod.id,
      ),
  )
